module.exports = __webpack_public_path__ + "media/images/middlecot-d40d48c545bfa762d2d025ea9cbcebc0.jpg";